import { makeAutoObservable, runInAction } from 'mobx'
import type { Notify } from '@/Ship/Contracts/Notify'
import { SendAssignmentPushTask } from '../Tasks/SendAssignmentPushTask'

/**
 * Local store of `ExecutorMessageModal`.
 *
 * Lets the dispatcher pick one of an executor's assignments (filtered to those
 * with an actual driver and not yet `completed_by_dispatcher`) and send a push
 * to that driver. If the executor has a single active driver it is preselected.
 */
export class ExecutorMessageModalStore {
    open = false
    assignments: any[] = []
    selectedAssignmentUuid: string | null = null
    message = ''
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    /**
     * Open the modal for the given executor. Returns `false` if there are no
     * eligible assignments — the view should surface an error to the user.
     */
    openFor(executor: any): boolean {
        const eligible: any[] = (executor?.assignments || []).filter(
            (a: any) => a?.driver?.uuid && a.status !== 'completed_by_dispatcher',
        )
        if (eligible.length === 0) return false
        this.assignments = eligible
        this.selectedAssignmentUuid = eligible.length === 1 ? eligible[0].uuid : null
        this.message = ''
        this.loading = false
        this.open = true
        return true
    }

    close(): void {
        this.open = false
        this.assignments = []
        this.selectedAssignmentUuid = null
        this.message = ''
        this.loading = false
    }

    setSelectedAssignment(uuid: string): void {
        this.selectedAssignmentUuid = uuid
    }

    setMessage(v: string): void {
        this.message = v
    }

    async send(notify: Notify): Promise<boolean> {
        if (!this.selectedAssignmentUuid) {
            notify.error('Оберіть водія')
            return false
        }
        const trimmed = this.message.trim()
        if (!trimmed) {
            notify.error('Введіть текст повідомлення')
            return false
        }
        this.loading = true
        try {
            await SendAssignmentPushTask(this.selectedAssignmentUuid, trimmed)
            notify.success('Повідомлення відправлено')
            this.close()
            return true
        } catch (e: any) {
            notify.error(e?.message || 'Не вдалося відправити повідомлення')
            runInAction(() => { this.loading = false })
            return false
        }
    }
}
